import { NarrativeCreateButton } from '../NarrativeCreateButton';
import { getNarrativeCommunityTitle } from './utils';
import { NarrativeCommunityBreadcrumbs } from '../NarrativeCommunityBreadcrumbs';
import InfoValuator from './images/info-valuator.svg';
import InfoAlert from './images/info-alert.svg';
import InfoDiscussion from './images/info-discussion.svg';
import { NarrativeCommunityHeaderInfoBlock } from './components/NarrativeCommunityHeaderInfoBlock';
import { cn } from '@simplywallst/ui-core/next';
import { useFlag } from '@/features/unleash';

type Props = {
  primaryIndustryLabel: string | undefined | null;
  primaryIndustrySlug: string | undefined | null;
  companyNameSlug: string | undefined | null;
  exchangeTicker: string | undefined | null;
  market: string | undefined | null;
  companyName: string | undefined | null;
  companyId: string | undefined | null;
  isLoading: boolean;
};

export const NarrativeCommunityHeader = ({
  primaryIndustryLabel,
  primaryIndustrySlug,
  companyNameSlug,
  exchangeTicker,
  market,
  companyName,
  companyId,
  isLoading,
}: Props) => {
  const title = getNarrativeCommunityTitle({
    companyName,
    primaryIndustryLabel,
    market,
  });
  const miniValuatorFlag = useFlag({
    name: 'mono-narrative-mini-valuator-hub',
  });
  const hasBreadcrumbs = !!market;
  const isMiniValuatorEnabled =
    miniValuatorFlag.enabled && miniValuatorFlag.flagsReady;

  return (
    <div className="border grid grid-rows-[repeat(3,max-content)] rounded-lg border-subtle bg-surface-1 px-x2 py-x3 text-solid lg:px-x4">
      <div className="grid grid-cols-[1fr_max-content] grid-rows-[repeat(2,max-content)] items-start gap-x1">
        <NarrativeCommunityBreadcrumbs
          market={market}
          primaryIndustrySlug={primaryIndustrySlug}
          exchangeTicker={exchangeTicker}
          companyNameSlug={companyNameSlug}
          companyName={companyName}
        />

        <div className="col-start-2 row-start-1 grid">
          <NarrativeCreateButton companyId={companyId} />
        </div>
        <div
          className={cn(
            'grid min-h-9',
            hasBreadcrumbs
              ? 'col-span-2 row-start-2'
              : 'col-span-1 row-start-1 items-center'
          )}
        >
          {isLoading ? (
            <div className="bones max-w-[300px]" />
          ) : (
            <h1 className="m-0 text-xl font-bold [word-break:break-word]">
              {title}
            </h1>
          )}
        </div>
      </div>
      <p className="text-soft">
        Our community narratives are driven by numbers and valuation.
      </p>
      <div
        role="list"
        className={cn(
          'grid justify-between gap-x1',
          isMiniValuatorEnabled
            ? 'lg:grid-cols-3'
            : 'md:grid-cols-3 lg:grid-cols-[repeat(3,260px)]'
        )}
      >
        <NarrativeCommunityHeaderInfoBlock
          icon={<InfoValuator width="100%" height="100%" />}
        >
          Value any stock for free in seconds
        </NarrativeCommunityHeaderInfoBlock>
        <NarrativeCommunityHeaderInfoBlock
          icon={<InfoAlert width="100%" height="100%" />}
        >
          Get alerts and valuation updates
        </NarrativeCommunityHeaderInfoBlock>
        <NarrativeCommunityHeaderInfoBlock
          icon={<InfoDiscussion width="100%" height="100%" />}
        >
          Participate in discussions
        </NarrativeCommunityHeaderInfoBlock>
      </div>
    </div>
  );
};
